import { TotalSalesSectionProps } from "./types";
import { HStack, VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { SaleValueInfo } from "../../infos/SaleValueInfo";
import { formatDateTimeString } from "@repo/core/utils/date.utils";

export const TotalSalesSection = ({
  title,
  dateTime,
  normalSales,
  noInterestSales,
  interestSales,
  cancelledSales,
  bonusUsed,
  withdraws,
  payments,
  fidelityPoints
}: TotalSalesSectionProps) => {
  return (
    <VStack gap={16} py="$4">
      <Text fontWeight={600}>{title}</Text>
      <HStack w="$full" justifyContent="space-between">
        <Text color="$textLight700" fontWeight={500} fontSize="$sm">
          Data e Hora
        </Text>
        <Text color="$textLight900">{formatDateTimeString(dateTime)}</Text>
      </HStack>
      <VStack
        borderRadius={8}
        borderWidth="$1"
        borderColor="$borderLight200"
        overflow="hidden"
      >
        <SaleValueInfo name="Vendas à vista" value={normalSales} />
        <SaleValueInfo name="Vendas SEM juros" value={noInterestSales} isGray />
        <SaleValueInfo name="Vendas COM juros" value={interestSales} />
        <SaleValueInfo name="Vendas canceladas" value={cancelledSales} isGray />
        <SaleValueInfo name="Bônus utilizados" value={bonusUsed} />
        <SaleValueInfo name="Saques" value={withdraws} isGray />
        <SaleValueInfo name="Pagamentos" value={payments} />
        <SaleValueInfo
          name="Pontos fidelidade"
          value={fidelityPoints}
          isGray
          isCurrency={false}
        />
      </VStack>
    </VStack>
  );
};
